import { Hidden } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { RangePicker } from "../../widgets";

function HiddenRangePicker(props) {
  const {
    handleDatesChange,
    fromDate,
    toDate,
    pickerClasses,
    monthsToDisplay = 1,
    hiddenFor = ["lg", "xl", "md"],
  } = props;
  return (
    <Hidden only={hiddenFor}>
      <div className={pickerClasses}>
        <RangePicker
          startDate={moment(new Date(fromDate))}
          endDate={moment(new Date(toDate))}
          monthsToDisplay={monthsToDisplay}
          onDatesChange={handleDatesChange}
        />
      </div>
    </Hidden>
  );
}

export default HiddenRangePicker;
